import type { RoutePath } from './router.model';

export type RouterAction = RouteChanged;

//////////////////////////////////////////////////
export interface RouteChanged {
  type: 'ROUTE_CHANGED';
  path: RoutePath;
  params?: object;
}
export function routeChanged(path: RoutePath, params?: object): RouteChanged {
  return {
    type: 'ROUTE_CHANGED',
    path,
    params,
  };
}
